import SITUATION from '@/i18n/fr/compta/situation/situation';

const COMPTA = {
  situation: SITUATION,
};

export default COMPTA;
